import { WidgetHandler } from '../../WidgetHandler';
import { callEventFunction } from './callEventFunction';
/**
 * Triggers the rendering of a form widget and handles change and auto-save events.
 *
 * @param {WidgetProps<any, any>} props - The props associated with the widget being rendered.
 * @param {object} [options] - Optional flags to control rendering and auto-save behavior.
 * @param {boolean} [options.changed] - Indicates if the data has changed; triggers `onChange` if true.
 * @param {boolean} [options.autoSaveDebounce] - If true, triggers auto-save with debounce behavior.
 * @param {boolean} [options.autoSaveImmediately] - If true, triggers immediate auto-save.
 * @returns {void}
 */
export function renderForm(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
props, options) {
    if (options === null || options === void 0 ? void 0 : options.changed) {
        props.internalData.changed = true;
        callEventFunction(props, 'onChange', 'value, handler', props.getData(), new WidgetHandler(props));
    }
    // eslint-disable-next-line testing-library/render-result-naming-convention
    const widgetData = props.render();
    if ((options === null || options === void 0 ? void 0 : options.changed) && props.rootParams.onChange) {
        props.rootParams.onChange(widgetData);
    }
    if (((options === null || options === void 0 ? void 0 : options.autoSaveDebounce) || (options === null || options === void 0 ? void 0 : options.autoSaveImmediately)) && props.rootParams.onAutoSave && widgetData.valid) {
        props.rootParams.onAutoSave(widgetData, !!(options === null || options === void 0 ? void 0 : options.autoSaveImmediately));
    }
}
